/**
 * Banner del regalo en el cart-drawer: actualizacion "en vivo".
 *
 * El banner se pinta en el servidor (snippets/cart-gift-message.liquid) y este script
 * lo mantiene al dia con cada cambio del carrito:
 *  - lo muestra o lo oculta segun lo que falta para el regalo (reaparece al quitar
 *    un producto y desaparece al llegar al minimo, las veces que haga falta),
 *  - actualiza la barra de progreso,
 *  - actualiza el importe con el mismo formato de dinero y moneda del mercado.
 *
 * CUANDO SE ACTUALIZA
 *  - con los eventos del tema (theme:cart:change / theme:cart:reload), y
 *  - cuando cambia el TOTAL del carrito en pantalla (el tema no lanza evento al
 *    quitar un producto o cambiar su cantidad dentro del drawer).
 *
 * A PRUEBA DE OCULTACIONES EXTERNAS
 *  - Si otro script del tema ocultara el banner (display:none en linea, atributo
 *    hidden...), al volver a tocar mostrarlo se deshace esa ocultacion.
 *  - Si alguien lo oculta mientras debe verse, un vigilante lo vuelve a mostrar.
 *
 * El producto regalo no cuenta para el minimo. Con el carrito vacio no se muestra.
 */
(function () {
  'use strict';
  if (window.__carnerGiftBanner) return;
  window.__carnerGiftBanner = true;

  var lastCart = null;
  var refreshTimer = null;
  var observed = [];
  var totalObserver = null;
  var guardObserver = null;
  var guarded = [];
  var guardBusy = false;

  function roots() {
    return document.querySelectorAll('[data-carner-gift]');
  }

  /** Deduce prefijo, sufijo, decimales y separadores del ejemplo de dinero. */
  function parseFormat(sample) {
    sample = String(sample || '');
    var m = sample.match(/\d[\d.,'’\s\u00a0\u202f]*\d/);
    if (!m) return null;
    var numeric = m[0];
    var decimals = 0;
    var decSep = '';
    if (/[.,]\d{2}$/.test(numeric)) {
      decimals = 2;
      decSep = numeric.charAt(numeric.length - 3);
    }
    var intPart = decimals ? numeric.slice(0, numeric.length - 3) : numeric;
    var t = intPart.match(/[^\d]/);
    return {
      prefix: sample.slice(0, m.index),
      suffix: sample.slice(m.index + numeric.length),
      decimals: decimals,
      decSep: decSep,
      thouSep: t ? t[0] : ''
    };
  }

  function formatMoney(cents, f) {
    var v = Math.max(0, cents) / 100;
    var s = f.decimals ? v.toFixed(2) : String(Math.round(v));
    var parts = s.split('.');
    var intStr = parts[0];
    if (f.thouSep) intStr = intStr.replace(/\B(?=(\d{3})+(?!\d))/g, f.thouSep);
    return f.prefix + (f.decimals ? intStr + f.decSep + parts[1] : intStr) + f.suffix;
  }

  /** Quita cualquier ocultacion externa del banner y de su contenedor interior. */
  function forceVisible(root) {
    var props = ['display', 'visibility', 'opacity', 'height', 'max-height'];
    for (var i = 0; i < props.length; i++) {
      if (root.style.getPropertyValue(props[i])) root.style.removeProperty(props[i]);
    }
    var holder = root.parentElement;
    if (holder && holder.id === 'GiftMessageContainer') {
      if (holder.style.display === 'none') holder.style.removeProperty('display');
      if (holder.hidden) holder.hidden = false;
    }
  }

  function update(cart) {
    if (!cart) return;
    guardBusy = true;
    var list = roots();
    var items = cart.items || [];
    for (var i = 0; i < list.length; i++) {
      var root = list[i];
      var limit = parseInt(root.getAttribute('data-limit-cents'), 10) || 0;
      var giftVariant = parseInt(root.getAttribute('data-gift-variant'), 10) || 0;

      var total = cart.total_price || 0;
      if (giftVariant) {
        for (var j = 0; j < items.length; j++) {
          if (Number(items[j].variant_id) === giftVariant) total -= items[j].final_line_price || 0;
        }
      }

      var remaining = limit - total;
      var show = limit > 0 && remaining > 0 && (cart.item_count || items.length) > 0;

      if (!show) {
        if (!root.hidden) root.hidden = true;
        continue;
      }

      if (root.hidden) root.hidden = false;
      forceVisible(root);

      var pct = Math.min(100, Math.max(0, Math.floor((total * 100) / limit)));
      var fill = root.querySelector('[data-carner-gift-fill]');
      if (fill && fill.style.width !== pct + '%') fill.style.width = pct + '%';

      if (!root._carnerFmt) root._carnerFmt = parseFormat(root.getAttribute('data-money-sample'));
      var amountEl = root.querySelector('[data-gift-to-spend]');
      if (amountEl && root._carnerFmt) {
        var txt = formatMoney(remaining, root._carnerFmt);
        if (amountEl.textContent.trim() !== txt) amountEl.textContent = txt;
      }
    }
    // Las mutaciones que acabamos de provocar no deben disparar al vigilante.
    setTimeout(function () { guardBusy = false; }, 0);
  }

  function usable(cart) {
    return !!cart && typeof cart.total_price === 'number' && Array.isArray(cart.items);
  }

  /** Pide el carrito real (una peticion pequena) y repinta el banner. */
  function refresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          lastCart = cart;
          update(cart);
        })
        .catch(function () {});
    }, 150);
  }

  /** Vigila el total del carrito en pantalla (cambia al quitar o cambiar cantidades). */
  function bindTotalObserver() {
    if (!window.MutationObserver) return;
    var els = document.querySelectorAll('[data-cart-final], [data-cart-subtotal]');
    var same = els.length === observed.length;
    if (same) {
      for (var i = 0; i < els.length; i++) {
        if (els[i] !== observed[i]) { same = false; break; }
      }
    }
    if (same) return;

    if (totalObserver) totalObserver.disconnect();
    observed = [];
    totalObserver = new MutationObserver(function () { refresh(); });
    for (var k = 0; k < els.length; k++) {
      observed.push(els[k]);
      totalObserver.observe(els[k], { childList: true, characterData: true, subtree: true });
    }
  }

  /**
   * Vigilante del propio banner: si otro script le cambia el estilo o el atributo
   * hidden mientras deberia verse (o al reves), se corrige con el ultimo carrito.
   */
  function bindGuard() {
    if (!window.MutationObserver) return;
    var list = roots();
    var nodes = [];
    for (var i = 0; i < list.length; i++) {
      nodes.push(list[i]);
      if (list[i].parentElement) nodes.push(list[i].parentElement);
    }
    var same = nodes.length === guarded.length;
    if (same) {
      for (var j = 0; j < nodes.length; j++) {
        if (nodes[j] !== guarded[j]) { same = false; break; }
      }
    }
    if (same) return;

    if (guardObserver) guardObserver.disconnect();
    guarded = nodes;
    guardObserver = new MutationObserver(function () {
      if (guardBusy || !lastCart) return;
      window.requestAnimationFrame(function () { update(lastCart); });
    });
    for (var k = 0; k < nodes.length; k++) {
      guardObserver.observe(nodes[k], { attributes: true, attributeFilter: ['style', 'hidden', 'class'] });
    }
  }

  function rebind() {
    bindTotalObserver();
    bindGuard();
  }

  document.addEventListener('theme:cart:change', function (e) {
    var cart = e && e.detail && (e.detail.cart || e.detail);
    if (usable(cart)) {
      lastCart = cart;
      update(cart);
    } else {
      refresh();
    }
    rebind();
  });

  // Tras una recarga del drawer el banner puede ser un elemento nuevo: se repinta al
  // momento con el ultimo carrito conocido y se confirma despues.
  document.addEventListener('theme:cart:reload', function () {
    if (lastCart) update(lastCart);
    refresh();
    rebind();
  });

  function init() {
    rebind();
    refresh();
    var drawer = document.getElementById('drawer-cart');
    if (drawer && window.MutationObserver) {
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(rebind, 200);
      }).observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', rebind);
})();